import React, { useMemo } from 'react';

import { useEditionAwareness } from '../../../services/edition-awareness-context';
import { getJiraProjectTypeKey } from '../../../services/get-jira-project-type-key';
import { ModalEntryPoint } from '../shared/modal-entry-point';

import { DIALOG_CONFIG } from './dialog-config';
import { entryPoint, type EntryPointParams } from './entrypoint';

export function FreeToStandardRefreshModal() {
	const { product, cloudId } = useEditionAwareness();

	const projectType = getJiraProjectTypeKey(product);

	if (!projectType) {
		throw new Error('Tried to render free to standard refresh dialog for unsupported product');
	}

	const entryPointParams: EntryPointParams = useMemo(
		() => ({
			cloudId,
			projectType,
		}),
		[cloudId, projectType],
	);

	const modalProps = useMemo(() => ({ width: 932, height: 500, autoFocus: false }), []);

	return (
		<ModalEntryPoint
			entryPoint={entryPoint}
			entryPointParams={entryPointParams}
			modalProps={modalProps}
			dialogConfig={DIALOG_CONFIG}
		/>
	);
}
